import React from "react";
import Carrusel2 from "../Componentes/carrusel2";
import "./certificados.css";
import SEO from "../Componentes/seo";

const Certificados = () => {
    return (
        <>
            <SEO
                title="Certificados y formación de Juan Camilo Muñoz"
                description="Revisa los certificados y formación de Juan Camilo Muñoz en desarrollo web, frontend, backend, CSS, JavaScript, SQL y marketing digital."
                path="/certificados"
                keywords={[
                    "certificados",
                    "formación",
                    "desarrollo web",
                    "JavaScript",
                    "React",
                    "Juan Camilo Muñoz"
                ]}
                structuredData={{
                    "@context": "https://schema.org",
                    "@type": "CollectionPage",
                    name: "Certificados y formación | Juan Camilo Muñoz",
                    url: "https://portafoliojcmr.netlify.app/certificados",
                    description:
                        "Certificados y formación profesional de Juan Camilo Muñoz en desarrollo web, frontend, backend y marketing digital."
                }}
            />
            <div className='app1Certificados'>
                <Carrusel2 />
            </div>
        </>
    );
}

export default Certificados;
